import {
  ReportAggregationIntervalType,
  ReportMetric,
  ReportOrderType,
  ReportValue,
  Team,
} from '@driftt/api-types'

export interface ISortConfig {
  metric: string
  order: ReportOrderType
}

export interface IQueryOptions {
  sortConfig?: ISortConfig
  keyword?: string
  exportData?: boolean
  pageSize?: number
  pageNumber?: number
  aggregateType?: ReportAggregationIntervalType
}

export interface ICompoundQuery {
  property?: string
  operation?: string
  values?: number[]
}

export interface IQueryConfig {
  metric: string
  startDate: string
  endDate: string
  value?: ReportValue | ReportValue[]
  botStatus?: string
  compoundQuery?: any
  teamSelected?: Team[]
  workspaceAgents?: { value: ReportValue }[]
  agentsSelected?: { value: ReportValue }[]
  widgetStatus?: string
  inboxSelected?: number
  classificationId?: number
  metrics?: ReportMetric[]
  timezone?: string
  playbookVersion?: number
}

export const HumanizedFilterOperations = {
  EQ: 'is',
  NEQ: 'is not',
  GT: '>',
  GTE: '≥',
  LT: '<',
  LTE: '≤',
  IN: 'is',
  NOT_IN: 'is not',
  BETWEEN: 'between',
}
